(function () {
	'use strict';

	/**
	 * @typedef {Object} DocumentNote
	 * @property {Number} id A unique id for the note object
	 * @property {String} text The note text
	 * @property {Date} date Timestamp when the note was created
	 * @property {Date} lastActivityDate Last date of note activity TODO: Find out exactly what this is
	 * @property {String} userName Name of the user that created the note
	 * @property {String} replyToUrl A link for replying to the note TODO: Don't know if we are supporting this
	 */

	/**
	 * @typedef {Object} NewDocumentNote
	 * @description
	 * An object that represents a new document note
	 * @property {String} text The note text
	 */

	angular.module('smb-app')
		.factory('smbDocumentNotesService', [
			'$http',
			'$q',
			'gettextCatalog',
			'pxUriPathService',
			DocumentNotesService
		]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbDocumentNotesService
	 * 
	 * @description
	 * Exposes methods for retrieving and creating document notes.
	 */
	function DocumentNotesService($http, $q, gettextCatalog, pxUriPathService) {

		return {
			/**
			 * @ngdoc method
			 * @name smbDocumentNotesService#getNotes
			 * @methodOf smb-app.smbDocumentNotesService
			 * @kind function
			 * 
			 * @description
			 * Gets the collection of all notes for a document
			 * 
			 * @param {String} documentId Id of the document whose notes are being retrieved.
			 *
			 * @returns {Deferred<DocumentNote>} A promise that resolves to a collection of @see DocumentNote objects
			 */
			getNotes: getNotes,

			/**
			 * @ngdoc method
			 * @name smbDocumentNotesService#createNote
			 * @methodOf smb-app.smbDocumentNotesService
			 * @kind function
			 * 
			 * @description
			 * Create a new note for a document
			 * 
			 * @param {NewDocumentNote} An object representing a new document note
			 * 
			 * @returns {Deferred<DocumentNote>} A promise that resolves to the newly created document note.
			 */
			createNote: createNote
		};

		function getNotes(documentId) {
			if (!documentId) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required document id')));
			}

			var uri = '/documents/' + documentId + '/comments';
			return $http.get(pxUriPathService.resolvePath(uri))
				.then(function(response) {
					return response.data.Embedded.Comments;
				})
				.then(function(data) {
					return data.map(commentToDocumentNote);
				});
		}

		function createNote(documentId, note) {
			if (!documentId) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required document id')));
			} else if (!(note && note.text)) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required note text')));
			}

			var comment = { CommentText: note.text };

			var uri = '/documents/' + documentId + '/comments';
			return $http.post(pxUriPathService.resolvePath(uri), comment)
				.then(function(response) {
					return response.data;
				})
				.then(commentToDocumentNote);
		}

		function commentToDocumentNote(comment) {
			return {
				id: comment.CommentId,
				text: comment.CommentText,
				date: comment.CommentDate,
				lastActivityDate: comment.LastActivityDate,
				userName: comment.UserName,
				replyToUrl: comment.Links && comment.Links.ReplyToUri
			};
		}

	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/documentNotesService.js
// module id = 150
// module chunks = 1